<template>
  <div>
    <ul>
      <li v-for="(item, index) in list" :key="index" class="vux-1px-b">
        <div @click="jump(item)" class="list smail" v-if="!item.isZone">
          <img :src="item.coverPicUrl" alt="" />
          <div>
            <div>{{ item.courseName }}</div>
            <p>
              <span style="margin-right: .2rem">{{ item.userName }}</span>
              <span>{{ item.duties }}</span>
            </p>
            <p>{{ item.hospitalName }}</p>
          </div>
        </div>
        <!-- 小程序中不显示 -->
        <div
          @click="jump(item)"
          class="list big"
          v-else-if="
            item.isZone && (!isHttps || (isHttps && !item.externalLink))
          "
        >
          <img :src="item.coverPicUrl" alt="" />
          <div class="bd">
            <span class="bs1">{{ item.courseName }}</span>
            <span class="bs2">订阅：{{ item.subNum }}人</span>
          </div>
        </div>
      </li>

      <!--<li>-->
      <!--<div class="list big">-->
      <!--<img src="//cdn.yxvzb.com/img/PCzhinanimgleft1017.png" alt="">-->
      <!--<div class="bd">-->
      <!--<span class="bs1">儿科治疗全攻略</span>-->
      <!--<span class="bs2">订阅：1306人</span>-->
      <!--</div>-->
      <!--</div>-->
      <!--</li>-->
    </ul>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    list: {
      type: Array,
      default: function() {
        return [
          {
            id: '9d7e429e-055a-4dc0-ad0a-aa1ddf92935d',
            title: '0808-8',
            coverPic: 'http://yxvzb.b0.upaiyun.com//images/1502164261767.jpg',
            userName: '李天',
            userDuty: '副主任医师',
            userCompanyName: '广州医科大学附属第五医院'
          }
        ];
      }
    }
  },
  data() {
    return {
      isHttps: false
    };
  },
  methods: {
    jump(item) {
      if (item.isZone) {
        if (item.externalLink) {
          location.href = item.externalLink;
        } else {
          this.$router.push({ name: 'universally', params: { id: item.id } });
        }
      } else {
        let wxUserInfoObj = this.$api.getStorage('wxUserInfo');

        sa.track(
          'classroomItem_click',
          {
            pageUrl: location.href,
            classroomId: item.id,
            classroomName: item.title,
            client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
            web_edition: 2
          },
          function() {}
        );

        this.$router.push({ name: 'courseDetail', params: { id: item.id } });
      }
    }
  },
  computed: {},
  components: {},
  created() {
    this.isHttps = this.$config.protocol === 'https';
  }
};
</script>
<style lang="less" scoped>
@import '../../../public/style/g.less';
.hidenText() {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    margin-top: 0.27rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .smail {
    }
    .list {
      margin-bottom: 0.8rem;
      img {
        display: block;
        width: 4.533rem;
        height: 2.56rem;
        border-radius: 0.1rem;
        margin-bottom: 0.1rem;
      }
      div {
        width: 4.533rem;
        font-size: 0.3733rem;
        color: #000;

        .textLimit();
      }
      p {
        width: 4.533rem;
        font-size: 0.32rem;
        color: #999;
        line-height: 1.3;
        .textLimit();
      }
    }
    .big {
      width: 100%;

      * {
        font-size: 0.3733rem;
      }
      img {
        width: 9.2rem;
        height: 4.4rem;
      }
      .bd {
        display: flex;
        justify-content: space-between;
        width: 100%;
        .bs1 {
          width: 6.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .bs2 {
          color: #999;
        }
      }
    }
  }
}
</style>
